module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "company-config"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('uploading', {
    attrs: {
      "uploaded": _vm.upload.uploaded,
      "total": _vm.upload.total,
      "visible": _vm.upload.visible,
      "image": _vm.upload.image
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Well Done!")]), _vm._v(" "), _c('p', [_vm._v("Saved successfully")])]), _vm._v(" "), _c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  }), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.needFill && !_vm.company.name) ? 'danger' : ''
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Company name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.company.name ? '' : 'Enter company name'
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.$set(_vm.company, "name", $$v)
      },
      expression: "company.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-baseline"
  }, [_vm._m(0), _vm._v(" "), _c('thumbnail', {
    attrs: {
      "picture": _vm.company.picture,
      "picture_url": _vm.company.picture_url
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.company, "picture", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.company, "picture_url", $event)
      },
      "change": function($event) {
        _vm.haveChanges = true
      }
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row align-items-baseline"
  }, [_vm._m(1), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "time"
    },
    on: {
      "change": function($event) {
        _vm.haveChanges = true
      }
    },
    model: {
      value: (_vm.company.logoff_after),
      callback: function($$v) {
        _vm.$set(_vm.company, "logoff_after", $$v)
      },
      expression: "company.logoff_after"
    }
  }), _c('span', [_vm._v(" (minimum of 1 hour)")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "text-left mt-2"
  }, [_vm._v("Admin account details")]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.needFill && !_vm.formData.first_name) ? 'danger' : ''
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("First name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.first_name ? '' : 'Enter name'
    },
    model: {
      value: (_vm.formData.first_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "first_name", $$v)
      },
      expression: "formData.first_name"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.needFill && !_vm.formData.last_name) ? 'danger' : ''
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Last name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.last_name ? '' : 'Enter last name'
    },
    model: {
      value: (_vm.formData.last_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "last_name", $$v)
      },
      expression: "formData.last_name"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    class: [(_vm.needFill && !_vm.formData.username && !_vm.formData.email) ? 'has-danger' : '', 'row']
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Username")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.username ? '' : 'Enter username'
    },
    model: {
      value: (_vm.formData.username),
      callback: function($$v) {
        _vm.$set(_vm.formData, "username", $$v)
      },
      expression: "formData.username"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (!_vm.needFill || _vm.formData.email.length == 0) ? '' : (!_vm.validateEmail(_vm.formData.email)) ? 'danger' : ''
    }
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.username && !_vm.formData.email) ? 'has-danger' : '', 'row align-items-baseline']
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Email")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.email ? '' : 'Enter email',
      "state": (!_vm.needFill || _vm.formData.email.length == 0) ? '' : (!_vm.validateEmail(_vm.formData.email)) ? 'danger' : ''
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Phone")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.phone ? '' : 'Enter Phone'
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.needFill && (!_vm.formData.id && !_vm.formData.password)) ? 'danger' : ''
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Password")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "password",
      "placeholder": _vm.formData.password ? '' : 'Enter password'
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 small red"
  }, [_vm._v("\n        Minimum password requirements "), _c('br'), _vm._v("6 characters, one capital, one number\n      ")])], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.formData.password.length == 0) ? '' : (_vm.formData.confirmPassword != _vm.formData.password) ? 'danger' : 'success'
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Confirm Password")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3 ",
    attrs: {
      "type": "password",
      "placeholder": _vm.formData.confirmPassword ? '' : 'Enter password',
      "state": (_vm.formData.password.length == 0) ? '' : (_vm.formData.confirmPassword != _vm.formData.password) ? 'danger' : 'success'
    },
    model: {
      value: (_vm.formData.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.formData, "confirmPassword", $$v)
      },
      expression: "formData.confirmPassword"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [(_vm.haveChanges || !_vm.company.id) ? _c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Save\n      ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.cancelData()
      }
    }
  }, [_vm._v("Cancel\n      ")])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "user_added",
    attrs: {
      "title": ""
    },
    on: {
      "ok": function($event) {
        return _vm.returnBack()
      },
      "hide": function($event) {
        return _vm.returnBack()
      }
    }
  }, [_vm._v("\n    User created\n\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "leavingConfirm",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n    You are about to leave page with unsaved changes?\n    "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.discardChanges()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.leavingConfirm.hide()
      }
    }
  }, [_vm._v("Cancel")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "auto",
      "margin-bottom": "auto"
    }
  }, [_c('b', [_vm._v("Company logo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Logoff after (hours)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52a5f4cf","hasScoped":true}!./src/components/companies/companyConfig/companyConfig.component.html
// module id = 543
// module chunks = 1